import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('keyFiguresSectionFigure', {
    count: {
        title: 'Count',
        type: 'number',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    label: {
        title: 'Label',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    suffix: {
        title: 'Suffix',
        type: 'string'
    }
});
var validator = z.object({
    count: z.number(),
    label: z.string(),
    suffix: z.string()
}).partial();
schema.keyFiguresSectionFigure;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=keyFiguresSectionFigure.js.map